<template>
    <div id="app" :class="{ isTouchEnabled: isTouch }" >
        <demo-message v-if="isDemo"></demo-message>
        <notifications></notifications>
        <modal></modal>
        <alerter ref="alerter"></alerter>
        <loading v-if="loading"></loading>
        <router-view id="main-view" class="scrollable" :class="{ 'is-demo': isDemo }"></router-view>
    </div>
</template>


<script>

import Vue from 'vue';
import track from 'js/helpers/analytics';
import notify from 'js/components/notifications/notificationsMixin';
import touch from 'js/components/auth/touchMixin';
import { isDemo } from 'js/api/auth'

import Loading from 'js/components/elements/Loading.vue';
import Notifications from 'js/components/notifications/Notifications.vue';
import Modal from 'js/components/elements/Modal.vue';
import Alerter from 'js/components/elements/Alerter.vue';
import DemoMessage from 'js/components/elements/DemoMessage.vue';

export default {
    name: 'Main',
    components: { Loading, Notifications, Modal, Alerter, DemoMessage },
    mixins: [ notify, touch ],
    data: function() {
        return {
            down: false,
        }
    },
    vuex: {
        getters: {
            loading: state => state.loading.user
        }
    },

    computed: {

        isDemo: function() {
            return this.$store.state.users.current && isDemo(this.$store.state.users.current)
        }

    },

    created: function() {

        Vue.http.interceptors.push( (request, next) => {

            next( response => {

                if( response.status === 401 ) {

                    // if a 401 comes through here, that means we've tried everything to authenticate, but could not get it to work
                    if ( this.$route.matched.some(record => record.meta.auth) ) {
                        this.$error( 'Je sessie is verlopen en je bent uitgelogd. Log opnieuw in om je werkmap te openen.', { id: 'auth' } )
                        this.$router.push({ name: 'logout', params: { _internal: true, _immediate: true } })
                    }

                } else if ( response.status === 410 ) {

                    this.$warn( 'De app wordt geüpdate naar een nieuwe versie...', { id: 'update' })

                } else if ( response.status === 429 ) {

                    this.$warn( 'Je hebt deze actie te vaak uitgevoerd. Probeer het na een minuut nog eens.' )

                } else if ( response.status === 503 ) {

                    this.$error( 'Je werkmap is tijdelijk niet beschikbaar wegens onderhoud. Probeer het later nog eens.' )

                } else if ( response.status >= 500 ) {

                    this.$error( 'Er is iets misgegaan.' )

                } else if ( response.status === 0 || response.status === 1 ) {

                    this.$error( 'Er kan geen verbinding worden gemaakt met de server. Probeer het later nog eens.', { id: 'connection' } )

                }

                this.down = [0, 1, 503].indexOf(response.status) >= 0

            })

        })

    },
}
</script>


<style lang="scss">
</style>



// WEBPACK FOOTER //
// Main.vue?50931dda